import React from "react";
import "./style.less";
import MdMailOutline from "@material-ui/icons/MailOutlineOutlined";
import DownloadFile from "../../components/common/download-file";
import DenseTable from "../../components/Dashboard/RenderTable";
import { IsTenant } from "../../utils/helper";


export default class AboutUs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      aboutUsData: null,
      aboutUsProduction: null,
      isUserManual: false
    };
    this.iconColor = "#FFFFFF";
    this.iconSize = "1.3em";
  }
  componentDidMount() {
    const configFilePath=  IsTenant() ? "/public/releases/tenantReleases/data-config.json" : "/public/releases/data-config.json";

    fetch(configFilePath)
      .then(res => res.json())
      .then(data => {
        this.setState({
          isUserManual: data.isUserManual,
          aboutUsData: data.stageAboutUs,
          aboutUsProduction: data.productionAboutUs
        });
      });
  }

  /** return version */
  getPreviousVersionColumnList = () => {
    // debugger;
    const columns = [];
    columns.push({
      name: "Version",
      key: "version"
    });
    columns.push({
      name: "Release Date",
      key: "releaseDate"
    });
    columns.push({
      name: "Description",
      key: "description"
    });
    columns.push({
      name: "Notes",
      key: "releaseNotesUrl",
      renderComponent: this.renderDownload
    });
    return columns;
  };

 
  /** download rendering */
  renderDownload = cellInfo => {
    return (
      <DownloadFile
        url={cellInfo.releaseNotesUrl}
        filename={cellInfo.downloadFilename}
      />
    );
  };

  /** Props */
  GetPropsForData = responseData => {
    return {
      data: responseData,
      columns: this.getPreviousVersionColumnList()
    };
  };

  /** return current environment URL */
  getCurrentEnvironment = () => {
    let environment = "dev";
    let clientId = "2b1e537e-9f0d-46ba-b4de-291a3948181a";
    let isLocal = false;
    // if (window.location.href.indexOf("https://streamdatum-dc") >= 0 || window.location.href.indexOf("operationsportal") >= 0) {
    if (window.location.href.indexOf("ui-dcopl-prd-eus") >= 0 || window.location.href.indexOf("https://dcop.stream-dc") >= 0) {
       clientId = "b3ea8035-a4ed-49ac-a3c8-83117805df09";
      environment = "prod";
    } else if (window.location.href.indexOf("ui-dcopl-stg-eus") > 0 || window.location.href.indexOf("stage-dcop.stream-dc") >= 0) {
      environment = "stage";
      clientId = "e3cb6b2f-6cea-4f43-a7c3-fe8cf9df3da7";
    } else if (window.location.href.indexOf("ui-dcopl-tst-eus") > 0 || window.location.href.indexOf("test-dcop.stream-dc") >= 0) {
      environment = "test";
      clientId = "b6c21d77-c4bd-4090-ac83-a8aad368ebc5";
    } else if (window.location.href.indexOf("localhost") > 0) {
      environment = "dev";
      isLocal = false;
    } else if (window.location.href.indexOf("ui-dcopl-dev-eus") > 0 || window.location.href.indexOf("dev-dcop.stream-dc") >= 0) {
       environment = "dev";
    }

    return { environment: environment, isLocal: isLocal, clientId: clientId };
  };

  render() {
    const { aboutUsData, aboutUsProduction, isUserManual } = this.state;
    const environment = this.getCurrentEnvironment();
    const aboutUsVersion =
      environment.environment == "prod" ? aboutUsProduction : aboutUsData;
    return (
      <div className={"about-us-container"}>
        <div className={"row margin-top-bottom "}>
          <div className={"col-xs-12"}>
            <span className={"header"}>{"About Us"}</span>
            <hr />
          </div>
        </div>
        {aboutUsVersion && (
          <>
            <div className={"row margin-top-bottom "}>
              <div className={"col-xs-12"}>
                <span className={"sub-header"}>
                  {"Data Center Operations Portal\r"}
                </span>
              </div>
            </div>
            <div className={"row margin-top-bottom "}>
              <div className={"col-xs-12 margin-top-bottom"}>
                <div className={" col-xs-12 col-sm-12 col-md-12 col-lg-12 no-padding description"}>
                  {aboutUsVersion.description}                  
                </div>  
                <hr />              
              </div>             
            </div>           
            <div className={"row margin-top-bottom  start-lg"}>
              <div className={"col-xs-12 col-sm-12 col-md-4 col-lg-3 content no-padding margin-top-bottom"}>
                <div className={"row no-padding  data-margin"}>
                  <div className={"col-xs  "}>
                    {"Last Updated on: "}&nbsp;{"\r"}
                    <span className={"badge"}>{aboutUsVersion.releaseDate}</span>
                  </div>
                </div>
              </div>

              <div className={"col-xs-12 col-sm-12 col-md-4 col-lg-3 content no-padding margin-top-bottom"}>
                <div className={"row no-padding  data-margin"}>
                  <div className={"col-xs "}>
                    {"Current version: "}&nbsp;{"\r"}
                    <span className={"badge"}>{aboutUsVersion.version}</span>
                  </div>
                </div>
              </div>
                <div className={"col-xs-12 col-sm-12 col-md-4 col-lg-6 content no-padding"}>
                  <div className={"row no-padding  data-margin"}>
                   { 
                    isUserManual && 
                    <div className={"col-xs "}>
                      {" "}
                      <span className={"badge download"}>
                        <DownloadFile
                          url={aboutUsVersion.userManualUrl}
                          filename={aboutUsVersion.userManualDownloadFileName}
                          labelText={"Download User Manual"}
                        />
                      </span>
                    </div>
                     } 
                  </div>
                </div>
            </div>

            <div className={"row margin-top-bottom section"}>
              <div className={"col-xs-12"}>
                <span className={"sub-header"}>{"Contact Us"}</span>
                <hr />
              </div>
              <div className={"col-xs-12"}>
                <span className={"description"}>
                  {aboutUsVersion.contactUs.description}
                </span>
              </div>
              <div className={"col-xs-12 col-sm-6 col-md-3 col-lg-4 content no-padding"}>
                <div className={"row col-xs-12 no-padding "}>
                  <div className={"col-xs-2"}>
                    <MdMailOutline fontSize={"small"} />
                  </div>
                  <div className={"col-xs-10 no-padding"}>
                    <a href={"mailto:" + aboutUsVersion.contactUs.email}>
                      {aboutUsVersion.contactUs.email}
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className={"row margin-top-bottom section"}>
              <div className={"col-xs-12"}>
                <span className={"sub-header"}>{"Previous Release"}</span>
                <hr />
              </div>
              <div className={"col-xs-12"}>
                <DenseTable
                  {...this.GetPropsForData(
                    aboutUsVersion["previousVersion"] || []
                  )}
                />
              </div>
            </div>
          </>
        )}
      </div>
    );
  }
}